import Config from './config.js';
const videoServerUrl = Config.videoServerURL;

const NETWORK_ISSUE = 0x1001;
const UNKNOWN_ERROR = 0x1002;

export function joinCall(token, agent, callback){

    let params = "?token="+token;
    if(agent)
      params = params +"&agent="+agent;
    fetch(videoServerUrl+"call/join"+params, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then( (response) => {
          console.log(response.status);
            response.text().then(function (text) {
              // do something with the text response
              try{
                let result = JSON.parse(text);
                if(response.status === 200){
                  callback(true, result.callid, 0);
                }else{
                  callback(false, result.status, result.reason);
                }
              }catch(err){
                callback(false, -1, UNKNOWN_ERROR);
              }
            });
      }).catch (function (error) {
          console.log('Request failed', error);
          callback(false, -1, NETWORK_ISSUE);
      });
    //callback(true, 1);

}

export function endCall(token, agent, callback){

    fetch(videoServerUrl+"call/endcall?token="+token+"&agent="+agent, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then( (response) => {
          console.log(response.status);
          if(response.status === 200){
            callback(true);
          }else{
            callback(false);
          }

      }).catch (function (error) {
          console.log('Request failed', error);
          callback(false);
      });

     // callback(true);

}

export function uploadImage(token, data, callback){
  fetch(videoServerUrl+"img/uploadimage?token="+token, {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    body: data
  })
  .then( (response) => {
      console.log(response.status);
      if(response.status === 200){
        callback(true);
      }else{
        callback(false);
      }

  }).catch (function (error) {
      console.log('Request failed', error);
      callback(false);
  });
}

export function getImages(token, callback){

  fetch(videoServerUrl+"img/fetch?token="+token, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then( (response) => {
        if(response.status === 200){
          response.text().then ((text)=>{
            console.log(text);
            callback(text);
          })

        }else{
          callback(false);
        }

    }).catch (function (error) {
        console.log('Request failed', error);
        callback(false);
    });

   // callback(true);

}

export function getRecordedVideos(token, callback){
  fetch(videoServerUrl+"rec/fetch?token="+token, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then( (response) => {
      if(response.status === 200){
        response.text().then ((text)=>{
          console.log(text);
          callback(text);
        })

      }else{
        callback(false);
      }

  }).catch (function (error) {
      console.log('Request failed', error);
      callback(false);
  });
}

export function deleteImage(token, img, callback){
  fetch(videoServerUrl+"img/delete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({token: token, image_name: img})
  })
  .then( (response) => {
      if(response.status === 200){
        callback(true);
      }else{
        callback(false);
      }
  }).catch (function (error) {
      console.log('Request failed', error);
      callback(false);
  });
}


export function deleteVideo(token, video, callback){
  fetch(videoServerUrl+"rec/delete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({token: token, recording_name: video})
  })
  .then( (response) => {
      if(response.status === 200){
        callback(true);
      }else{
        callback(false);
      }
  }).catch (function (error) {
      console.log('Request failed', error);
      callback(false);
  });
}